import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { seguridadDAModulo } from "src/app/aplicaciones-modulos/seguridadDA/diccionarios/seguridadDAModule";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { EmployeModel } from '../../model/employeModel';
import { CaracteristicaService } from '../../services/caracteristica.service';
import { AplicacionUserService } from '../../services/aplicacionUser.service';

@Component({
  selector: 'app-gestion-alias',
  templateUrl: './gestion-alias.component.html',
  styleUrls: ['./gestion-alias.component.css']
})
export class GestionAliasComponent implements OnInit {

  seguridadDAModulo: any = {};
  loading: boolean = false;
  empleado: EmployeModel;
  
  frameworkComponents: any;
  columnDefs: any[] = [];
  rowData: any[] = [];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  textoBuscar: string;

  formulario = new FormGroup({
    cedula: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]),
    nombres: new FormControl('', [Validators.required]),
    dscaLocalidad: new FormControl(''),
    statusEmpleado: new FormControl(''),
    apellidoParterno: new FormControl(''),
    apellidomaterno: new FormControl(''),
    codEmpleado: new FormControl(''),
    codigoBp: new FormControl('')
  });

  constructor(
    private _util: UtilsService,
    private _aplicacionUser: AplicacionUserService
  ) { }

  ngOnInit() {
    this.seguridadDAModulo = seguridadDAModulo;
    this.cargarGrid();
  }

  cargarGrid() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent };

    this.columnDefs = [
      { field: 'clave', filter: true, resizable: true, width: 200},
      { field: 'valor', filter: true, resizable: true, width: 200},
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getEmpleado(event) {
    let cedula = this.formulario.get('cedula').value;

    this.formulario.get('nombres').reset();
    this.formulario.get('dscaLocalidad').reset();
    this.formulario.get('statusEmpleado').reset();
    this.rowData = [];

    this._aplicacionUser.getEmpleadoByCedula(cedula).subscribe((res: any) => {
      if (res) {
        this.empleado = res;
        this.formulario.patchValue(res);
        this.formulario.get('nombres').setValue(res.primerNombre);
        this.formulario.get('dscaLocalidad').setValue(res.dscaLocalidad);
        this.formulario.get('statusEmpleado').setValue(res.statusEmpleado);        
      } else {
        this._util.mensajeOKToast("No se encontró empleado", 3000);
        this.empleado = null;
      }
    }, (err) => {
      console.log(err.message);
      this._util.mensajeErroToast("Error al buscar empleado");
    });
  }

  consultarAlias() {
    if (this.formulario.get('cedula').invalid) {
      this._util.mensajeErrorVisto("Debe ingresar una cédula válida");
      return;
    }

    let cedula = this.formulario.get('cedula').value;
    this.loading = true;

    this._aplicacionUser.getNickNamesByCedula(cedula).subscribe((res: any) => {
      this.loading = false;
      if (res) {
        this.rowData = res;
        if (this.rowData.length === 0) {
          this._util.mensajeOKToast("No se encontraron alias para este empleado", 3000);
        }
      } else {
        this.rowData = [];
        this._util.mensajeOKToast("No se encontraron alias", 3000);
      }
    }, (err) => {
      this.loading = false;
      console.log(err);
      this.rowData = [];
      this._util.mensajeErroToast(err.error?.message || "Error al consultar alias");
    });
  }

}
